<template>
    <v-layout
      wrap
      column
      justify-start
      :class="!bMini ? 'viewLayoutWrapper MiniPadding' : 'viewLayoutWrapper'"
    >
      <!-- #region Start title -->
      <p class="SectionTitle">
        <v-btn style="margin-right: -10px" icon fab small href="/admin/providers">
          <v-icon style="font-size: 30px; color: black;">
            mdi-chevron-left
          </v-icon>
        </v-btn>
        Órdenes del proveedor : {{ sSupplier }}
      </p>
      <!-- #endregion End title -->
  
      <v-tabs v-model="iTab" background-color="transparent" class="content-header-tab-all-global" >
        <v-tab class="content-header-tab-global"  v-for="(item, i) in aItemsTab" :key="i">
          {{ item.text }}
        </v-tab>
      </v-tabs>
  
      <v-tabs-items v-model="iTab" class="content-tab-all-global" >
        <v-tab-item v-for="(item, i) in aItemsTab" :key="i">
          <!-- #region Start search component -->
          <search-supplier
          class="mt-5"
            v-if="i == 0"
            :loading="bLoading"
            :mdUp="mdUp"
            :smUp="smUp"
            :texts="sectionTxt"
          >
          </search-supplier>
          <!-- #endregion End search component -->
          <KeepAlive>
            <component
              :is="item.component"
              :mdUp="mdUp"
              :smUp="smUp"
              :texts="sectionTxt"
            />
          </KeepAlive>
        </v-tab-item>
      </v-tabs-items>
  
  
    </v-layout>
  </template>
  <script>
  export default {
    data: () => ({
      bLoading: false,
      iTab: 0,
      aItemsTab: [
        { text: "Órdenes de compra", component: "TableSupplier" },
        { text: "Compra anticipada", component: "AdvancePurchase" },
      ],
    }),
    components: {
      // import search component
      SearchSupplier: () => import("../../components/views/Supplier/Search"),
      // import table sypplier component
      TableSupplier: () => import("../../components/views/Supplier/Table"),
      //import advance purchase component
      AdvancePurchase: () =>
        import("../../components/core/AdvancePurchase"),
    },
    props: {
      // import texts from admin
      texts: Object,
      mdUp: Boolean,
      smUp: Boolean,
      bMini: Boolean,
    },
    computed: {
      sSupplier() {
        return this.$store.state.supplierSelected.sFullName;
      },
      // section texts
      sectionTxt() {
        return this.texts.providers;
      },
    },
  };
  </script>
  
  